const config = {
    db_name: 'zskk-ris-log-3.0',
    db_version: 20190115,
    db_tables: [{
            table_name: 'logs',
            options:  {
                keyPath : "id" ,
                autoIncrement: true,
            },
            indexs:[
                {
                    index_key: 'day_index',
                    filed_name: 'day',
                    index_options:{ unique:false }
                },
                {
                    index_key: 'level_index',
                    filed_name: 'level',
                    index_options:{ unique:false }
                },
                {
                    index_key: 'token_index',
                    filed_name: 'token',
                    index_options:{ unique:false }
                },
                {
                    index_key: 'url_index',
                    filed_name: 'url',
                    index_options:{ unique:false }
                }
            ]
        }
    ]
}
export default config